module.exports = "https://media.zlongame.com/media/pictures/cn/vipCenter/assets/img/appkeyIcon/icon_1693534261653.png";